import type { EntityStatus } from '@ms/yammer-data-support';
import { getStatusForId as getStatus } from '@ms/yammer-data-support';

import type { File, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';
import type { FindById, FindByIdThrows } from '../findById';
/**
 * @deprecated PERFORMANCE This returns an entity object which will force re-renders whenever it gets updated by a related API call.
 * This should be replaced by a `getFileField` selector.
 */
export const findById: FindById<'files'> = createFindById('files');
/**
 * @deprecated PERFORMANCE This returns an entity object which will force re-renders whenever it gets updated by a related API call.
 * This should be replaced by a `getFileFieldThrows` selector.
 */
export const findByIdThrows: FindByIdThrows<'files'> = createFindByIdThrows('files');
type FileVisibilityByReferenceSelector = (state: YammerState, fileId: File['id']) => boolean;
export const isDeleted: FileVisibilityByReferenceSelector = (state, fileId) => {
  const file = findByIdThrows(state, fileId);

  return isFileDeleted(file);
};
export const isInaccessible: FileVisibilityByReferenceSelector = (state, fileId) => {
  const file = findByIdThrows(state, fileId);

  return isFileInaccessible(file);
};
export const isActive: FileVisibilityByReferenceSelector = (state, fileId) => {
  const file = findByIdThrows(state, fileId);

  return isFileActive(file);
};
type FileVisibilitySelector = (file: File) => boolean;
export const isFileDeleted: FileVisibilitySelector = (file) => file.state === 'DELETED';
export const isFileActive: FileVisibilitySelector = (file) => file.state === 'ACTIVE';
export const isFileInaccessible: FileVisibilitySelector = (file) => file.state === 'INACCESSIBLE';
type GetFulfilledFiles = (state: YammerState) => Record<string, File>;
export const getFulfilledFiles: GetFulfilledFiles = (state) => state.files.fulfilled.byId;
type GetStatusForId = (state: YammerState, fileId: File['id']) => EntityStatus;
export const getStatusForId: GetStatusForId = (state, fileId) => getStatus(state.files, fileId);
